export enum CurrencyEnum {
  USD = "USD",
  EUR = "EUR",
  UAH = "UAH",
}

export enum RecordTypeEnum {
  Asset = "Asset",
  Debt = "Debt",
}
